import { render } from "./WalletBreakdownByInstrumentType.vue?vue&type=template&id=710ec93c&scoped=true"
import script from "./WalletBreakdownByInstrumentType.vue?vue&type=script&lang=js"
export * from "./WalletBreakdownByInstrumentType.vue?vue&type=script&lang=js"

import "./WalletBreakdownByInstrumentType.vue?vue&type=style&index=0&id=710ec93c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-710ec93c"]])

export default __exports__